module.exports = __webpack_public_path__ + "img/unknown.1bf04b59.jpg";